/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _basicInviteJs = __webpack_require__(1);
	
	var _basicInviteJs2 = _interopRequireDefault(_basicInviteJs);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pomoho on 15/9/15.
	 */
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dataJs = __webpack_require__(2);
	
	var _dataJs2 = _interopRequireDefault(_dataJs);
	
	var _gaJs = __webpack_require__(3);
	
	var _gaJs2 = _interopRequireDefault(_gaJs);
	
	var locale = (navigator.language || navigator.userLanguage || navigator.browserLanguage).toLowerCase().replace('-', '_');
	if (_dataJs2['default'].mainText[locale]) {
		document.title = _dataJs2['default'].mainText[locale][0]['pageTitle'];
		document.getElementById('textWrapper').innerHTML = template('itemList', { list: _dataJs2['default'].mainText[locale] });
		document.getElementById('coverText').innerHTML = template('coverList', { list: _dataJs2['default'].coverText[locale] });
	} else {
		document.title = _dataJs2['default'].mainText[locale][0]['en_us'];
		document.getElementById('textWrapper').innerHTML = template('itemList', { list: _dataJs2['default'].mainText['en_us'] });
		document.getElementById('coverText').innerHTML = template('coverList', { list: _dataJs2['default'].coverText['en_us'] });
	}
	var usedLink = undefined;
	var u = navigator.userAgent;
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	var referrer = window.location.search.substring(1).split('=')[1];
	var googlePlayUrl = referrer == '' || referrer == undefined ? 'https://play.google.com/store/apps/details?id=com.emoji.keyboard.touchpal' : 'https://play.google.com/store/apps/details?id=com.emoji.keyboard.touchpal&referrer=' + referrer;
	var appStoreUrl = 'http://app.appsflyer.com/id909654683';
	
	if (isiOS) {
		usedLink = appStoreUrl;
	} else if (isAndroid) {
		usedLink = googlePlayUrl;
	} else {
		usedLink = 'http://ime.service.cootek.com/default/webpage/download_redirect/download.html';
	}
	var downloadButton = document.getElementsByClassName('button')[0];
	downloadButton.onclick = function () {
		(0, _gaJs2['default'])('send', 'event', 'download');
		//document.getElementById('cover').style.display = 'block';
		if (u.toLowerCase().indexOf('micromessenger') >= 0) {
			document.getElementById('cover').style.display = 'block';
		} else {
			window.location.href = usedLink;
		}
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	/**
	 * Created by pomoho on 15/9/15.
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = {
		mainText: {
			en_us: [{
				pageTitle: 'Get $4.99 Premium membership for FREE',
				welcomeTitle: 'Welcome!',
				welcomeSub: 'Your friends invite you to enjoy the typing fun of TouchPal keyboard. Download now and both of you will receive one month of TouchPal Premium service for free.',
				buttonText: 'Download & Receive',
				touchpalTitle: 'What is TouchPal?',
				touchpalSub: 'TouchPal Emoji Keyboard. It’s a free emoji keyboard app for Android users to type fast and easy with the best word prediction, over 800 emoji and emoticons, smartest auto-correction and swipe. TouchPal Emoji Keyboard is trusted by over 300 million users all over the world.'
			}],
			zh_cn: [{
				pageTitle: '立即领取$4.99会员资格',
				welcomeTitle: '欢迎！',
				welcomeSub: '您的好友邀请您一起感受触宝输入法的神奇。 立即下载触宝输入法, 您和您的好友即可免费领取各一个月触宝尊享会员资格。',
				buttonText: '下载并领取',
				touchpalTitle: '触宝是什么?',
				touchpalSub: '触宝输入法是最有趣最快速的手机输入法。 800+ Emoji表情, 智能纠错, 滑行输入, 超强预测能让您变成朋友眼中更有趣的人哦。'
			}],
			zh_tw: [{
				pageTitle: '立即領取$4.99會員資格',
				welcomeTitle: '歡迎！',
				welcomeSub: '您的好友邀請您一起感受觸寶輸入法的神奇。 立即下載觸寶輸入法, 您和您的好友即可免費領取各一個月觸寶尊享會員資格。',
				buttonText: '下載並領取',
				touchpalTitle: '觸寶是什麽?',
				touchpalSub: '觸寶輸入法是最有趣最快速的手機輸入法。 800+ Emoji表情, 智能糾錯, 滑行輸入, 超強預測能讓您變成朋友眼中更有趣的人哦。'
			}],
			zh_hk: [{
				pageTitle: '立即領取$4.99會員資格',
				welcomeTitle: '歡迎！',
				welcomeSub: '您的好友邀請您一起感受觸寶輸入法的神奇。 立即下載觸寶輸入法, 您和您的好友即可免費領取各一個月觸寶尊享會員資格。',
				buttonText: '下載並領取',
				touchpalTitle: '觸寶是什麼?',
				touchpalSub: '觸寶輸入法是最有趣最快速的手機輸入法。 800+ Emoji表情, 智能糾錯, 滑行輸入, 超強預測能讓您變成朋友眼中更有趣的人哦。'
			}]
		},
		coverText: {
			en_us: [{
				click: 'Click',
				open: 'open with browser'
			}],
			zh_cn: [{
				click: '点击',
				open: '在浏览器打开'
			}],
			zh_tw: [{
				click: '點擊',
				open: '在瀏覽器打開'
			}],
			zh_hk: [{
				click: '點擊',
				open: '在瀏覽器打開'
			}]
		}
	
	};
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	window.GoogleAnalyticsObject = "ga";
	window.ga = function () {
		(window.ga.q = window.ga.q || []).push(arguments);
	};
	window.ga.l = 1 * new Date();
	
	if (window.location.host.indexOf('cootekservice') > 0) {
		ga('create', 'UA-44448382-2', 'cootekservice.com');
	} else {
		ga('create', 'UA-44448382-3', 'cootek.com');
	}
	window.ga("send", "pageview");
	
	exports['default'] = function () {
		window.ga.apply(this, arguments);
	};
	
	;
	module.exports = exports['default'];

/***/ }
/******/ ]);
//# sourceMappingURL=main.js.map